import { NotificationsNone as BellIcon } from '@mui/icons-material';
import { Box } from '@pulse/ui';

export interface NotificationFabProps {
  unreadCount: number;
}

// `unreadCount` is a prop, not read from a notifications context directly — keeps this
// usable as the `fab` slot for any future FloatingPanel content, not just notifications.
export function NotificationFab({ unreadCount }: NotificationFabProps) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <BellIcon sx={{ fontSize: 26 }} />
      {unreadCount > 0 && (
        <Box
          sx={{
            position: 'absolute',
            top: -6,
            right: -8,
            minWidth: 18,
            height: 18,
            borderRadius: '9px',
            bgcolor: 'error.main',
            color: 'common.white',
            fontSize: '0.6rem',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 0.4,
            lineHeight: 1,
            border: '2px solid',
            borderColor: 'primary.main',
          }}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </Box>
      )}
    </Box>
  );
}
